import LayoutShape, { isLayoutContainerShape } from './LayoutShape';
import { WidgetInfo } from 'widgets/WidgetInfo';

export enum LayoutStatus {
    NONE = 'NONE',
    PENDING = 'PENDING',
    SUCCESS = 'SUCCESS',
    ERROR = 'ERROR',
}

export interface LayoutErrorState {
    name: string;
    origin: string;
    message: string;
}

export const LayoutVersions = [
    'Initial',
    'Ind2176CapsuleConfigMovedToContainer',
    'Ind2930LayoutSelectionDropdownConfusion',
];

export interface Layout {
    id: number | null;
    name: string;
    origin: string;
    shape: LayoutShape | undefined;
    components: WidgetInfo[];
    activeInputId: string | undefined;
    version?: number;
}

export interface LayoutState {
    status: LayoutStatus;
    panelId?: string;
    error?: LayoutErrorState;
    result?: Layout;
    pendingLayout?: { name: string; panelId?: string };
    manualSave?: boolean;
    isDirty?: boolean;
}

export const defaultLayout: LayoutState = {
    status: LayoutStatus.NONE,
};

export const initialLayoutState = defaultLayout;

export function isLayoutEmpty(layout: Layout | undefined) {
    return (
        layout &&
        (!layout.shape ||
            (isLayoutContainerShape(layout.shape) &&
                layout.shape.content.length === 0))
    );
}
